import { PropsWithChildren, useCallback, useState } from "react";
import { DashboardDateRangeContextProvider, DashboardDateRange } from "../../context";
import { subDays } from "date-fns";

export const DateRangeContextProvider = ({ children }: PropsWithChildren) => {
  const today = new Date();

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    subDays(today, 28),
    today
  ]);

  const updateDateRange = useCallback((dateRange: [Date | null, Date | null]) => {
    setDateRange(dateRange);
  }, []);

  const initialState: DashboardDateRange = {
    startDate: dateRange[0],
    endDate: dateRange[1],
    setDateRange: updateDateRange
  };

  return (
    <DashboardDateRangeContextProvider value={initialState}>
      {children}
    </DashboardDateRangeContextProvider>
  );
};
